import type { NavigationConfig } from "@ghm/domain";
export { NAVIGATION_ICONS, NAVIGATION_LIMITS } from "@ghm/domain";
export type { NavigationConfig, NavigationGroup, NavigationIcon } from "@ghm/domain";

export const EMPTY_NAVIGATION: NavigationConfig = { revision: 0, groups: [] };
